export default () => {
	const refreshTokenexists = window.localStorage.getItem('refreshToken');
	const refreshTokenValid = window.localStorage.getItem('refreshTokenTimeout') > Date.now();

	return refreshTokenexists && refreshTokenValid;
};
